import { applyMiddleware, createStore } from 'redux'

import { createLogger } from 'redux-logger'
import createRavenMiddleware from 'internal-components/src/redux/middleware/raven'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'react-router-redux'

import rootReducer from './modules'
import createRootSaga from './sagas'

export default function configureStore(
  invocation,
  sso,
  { debug, errorHandler, history, initialState, raven, ...sagaOptions },
) {
  const [sagaMiddleware, middleware] = buildMiddleware(
    errorHandler,
    debug,
    history,
    raven,
  )
  const store = middleware(createStore)(rootReducer, initialState)

  if (module.hot) {
    module.hot.accept('./modules', () => {
      // eslint-disable-next-line global-require
      const nextRootReducer = require('./modules')

      store.replaceReducer(nextRootReducer)
    })
  }

  sagaOptions.addressSearch = async q => {
    return await invocation.searchAddress(undefined, q)
  }

  sagaMiddleware.run(
    createRootSaga({ invocation, sso }, { raven, ...sagaOptions }),
  )

  return store
}

function buildMiddleware(errorHandler, debug, history, raven) {
  const excludedSagaActions = [
    'EFFECT_TRIGGERED',
    'EFFECT_RESOLVED',
    'EFFECT_REJECTED',
  ]

  const sagaMiddleware = createSagaMiddleware({
    onError: errorHandler,
  })

  const middlewares = [
    sagaMiddleware,
    createLogger({
      collapsed: true,
      duration: true,
      timestamp: false,
      predicate: (getState, action) =>
        debug && excludedSagaActions.indexOf(action.type) === -1,
    }),
    routerMiddleware(history),
  ]

  if (raven) {
    middlewares.unshift(createRavenMiddleware(raven, excludedSagaActions))
  }

  return [sagaMiddleware, applyMiddleware(...middlewares)]
}



// WEBPACK FOOTER //
// ./src/redux/configureStore.js